import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminSettingApi from "../../api/admin/AdminSetting";
import {
  AssignmentDto,
  CreateOrUpdateAllowIPDto,
  TypeDto,
} from "../../../types/adminSetting";

interface AdminSettingState {
  manageTypeList: TypeDto[];
  assignmentList: AssignmentDto[];
}
// # initial state
const initialState: AdminSettingState = {
  manageTypeList: [] as TypeDto[],
  assignmentList: [] as AssignmentDto[],
};
export const trunkGetManageType = createAsyncThunk(
  "wapi/admins/manage/type",
  async () => {
    const resp = await adminSettingApi.getManageType();
    return resp;
  }
);
export const trunkCreateManageType = createAsyncThunk(
  "wapi/admins/manage/type/create",
  async (option: TypeDto) => {
    const result = await adminSettingApi.createManageType(option);
    return result;
  }
);
export const trunkUpdateManageType = createAsyncThunk(
  "wapi/admins/manage/type/update",
  async (option: TypeDto) => {
    const result = await adminSettingApi.updateManageType(option);
    return result;
  }
);
export const trunkDeleteManageType = createAsyncThunk(
  "wapi/admins/manage/type/delete",
  async (ids: string[]) => {
    const result = await adminSettingApi.deleteManageType(ids);
    return result;
  }
);
export const trunkGetAssingment = createAsyncThunk(
  "wapi/admins/manage/assignment",
  async () => {
    const resp = await adminSettingApi.getAssingment();
    return resp;
  }
);
export const trunkCreateAssignment = createAsyncThunk(
  "wapi/admins/manage/assignment/create",
  async (option: CreateOrUpdateAllowIPDto) => {
    const result = await adminSettingApi.createAssingment(option);
    return result;
  }
);
export const trunkUpdateAssignment = createAsyncThunk(
  "wapi/admins/manage/assignment/update",
  async (option: CreateOrUpdateAllowIPDto) => {
    const result = await adminSettingApi.updateAssingment(option);
    return result;
  }
);
export const trunkDeleteAssignment = createAsyncThunk(
  "wapi/admins/manage/assignment/delete",
  async (ids: string[]) => {
    const result = await adminSettingApi.deleteAssingment(ids);
    return result;
  }
);
const adminSettingSlice = createSlice({
  name: "adminLogin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        trunkGetManageType.fulfilled,
        (state, { payload: newTypeList }) => {
          newTypeList = newTypeList.sort((a, b) => {
            const nameA = a.atName.toLowerCase().trim();
            const nameB = b.atName.toLowerCase().trim();
            return nameA.localeCompare(nameB);
          });
          state.manageTypeList = newTypeList;
        }
      )
      .addCase(
        trunkCreateManageType.fulfilled,
        (state, { payload: newType }) => {
          state.manageTypeList.push(newType);
          let newTypeList = state.manageTypeList;
          newTypeList.sort((a, b) => {
            const nameA = a.atName.toLowerCase().trim();
            const nameB = b.atName.toLowerCase().trim();
            return nameA.localeCompare(nameB);
          });
          state.manageTypeList = newTypeList;
        }
      )
      .addCase(
        trunkUpdateManageType.fulfilled,
        (state, { payload: newType }) => {
          let newTypeList = state.manageTypeList;
          newTypeList.filter(
            (item) => item.atCode === newType.atCode
          )[0].atName = newType.atName;
          newTypeList.filter(
            (item) => item.atCode === newType.atCode
          )[0].atDesc = newType.atDesc;
          newTypeList.filter(
            (item) => item.atCode === newType.atCode
          )[0].atMenuScope = newType.atMenuScope;

          newTypeList = newTypeList.sort((a, b) => {
            const nameA = a.atName.toLowerCase().trim();
            const nameB = b.atName.toLowerCase().trim();
            return nameA.localeCompare(nameB);
          });

          state.manageTypeList = newTypeList;
        }
      )
      .addCase(trunkDeleteManageType.fulfilled, (state, { payload: codes }) => {
        state.manageTypeList = state.manageTypeList.filter(
          (item) => item.atCode && !codes.includes(item.atCode)
        );
      })
      .addCase(trunkGetAssingment.fulfilled, (state, action) => {
        let newAssignmentList = action.payload;
        newAssignmentList = newAssignmentList.sort((a, b) => {
          const nameA = a.userInfo?.name?.toLowerCase().trim() ?? "";
          const nameB = b.userInfo?.name?.toLowerCase().trim() ?? "";
          return nameA.localeCompare(nameB);
        });
        state.assignmentList = newAssignmentList;
      })
      .addCase(
        trunkUpdateAssignment.fulfilled,
        (state, { payload: updatedAdmin }) => {
          state.assignmentList.filter(
            (item) => item.adminId === updatedAdmin.adminId
          )[0].allowIpList = updatedAdmin.allowIpList;
          state.assignmentList.filter(
            (item) => item.adminId === updatedAdmin.adminId
          )[0].multiFactor = updatedAdmin.multiFactor;
          state.assignmentList.filter(
            (item) => item.adminId === updatedAdmin.adminId
          )[0].atCode = updatedAdmin.atCode;
          state.assignmentList.filter(
            (item) => item.adminId === updatedAdmin.adminId
          )[0].updatedTime = updatedAdmin.updatedTime;
        }
      )
      .addCase(
        trunkDeleteAssignment.fulfilled,
        (state, { payload: deletedAdmin }) => {
          let deletedIds = deletedAdmin.map((item) => item.adminId);
          state.assignmentList = state.assignmentList.filter(
            (item) => !deletedIds.includes(item.adminId)
          );
        }
      );
  },
});
export const adminSettingActions = adminSettingSlice.actions;
export default adminSettingSlice.reducer;
